<div class="login-shell min-h-screen flex flex-col bg-gradient-to-b from-cloud-mist via-snow-white to-cloud-mist font-sans">

  <header class="flex shrink-0 items-center justify-between px-4 py-4 sm:px-8">
    <a
      routerLink="/"
      class="inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-[13px] font-medium text-slate-blue transition-colors hover:bg-white/60 hover:text-midnight-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-action-blue/40">
      <svg class="h-4 w-4 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
      </svg>
      Inicio
    </a>
    <a
      routerLink="/explorar"
      class="text-[13px] font-medium text-slate-blue transition-colors hover:text-midnight-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-action-blue/40 rounded-lg px-2 py-1.5">
      Explorar espacios
    </a>
  </header>

  <div class="flex flex-1 items-center justify-center px-4 pb-10 sm:pb-14">
    <div class="login-layout w-full max-w-[920px]">

      <!-- Brand panel (desktop) -->
      <aside class="login-brand hidden lg:flex flex-col justify-center pr-4">
        <a routerLink="/" class="mb-8 inline-block focus:outline-none focus-visible:ring-2 focus-visible:ring-action-blue/40 rounded-md">
          <img src="assets/logo.svg" alt="TimeFlexRent" class="h-10 w-auto" />
        </a>
        <h1 class="text-[32px] font-bold leading-[1.15] tracking-tight text-midnight-indigo mb-3">
          {{ mode === 'login' ? 'Tu panel, a un clic' : 'Publica y gestiona tus espacios' }}
        </h1>
        <p class="text-[15px] leading-relaxed text-slate-blue max-w-md mb-8">
          @if (mode === 'login') {
            Accede para reservar salas, revisar tus reservas o administrar tus locales.
          } @else {
            Crea tu cuenta de propietario y empieza a recibir reservas con disponibilidad en tiempo real.
          }
        </p>
        <ul class="space-y-3 text-[14px] text-slate-blue">
          <li class="flex items-start gap-3">
            <span class="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-action-blue/10 text-action-blue text-xs font-bold">1</span>
            <span>Reservas y calendario sincronizados</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-action-blue/10 text-action-blue text-xs font-bold">2</span>
            <span>Pagos seguros con Stripe</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-action-blue/10 text-action-blue text-xs font-bold">3</span>
            <span>Gestión sencilla desde cualquier dispositivo</span>
          </li>
        </ul>
      </aside>

      <!-- Form card -->
      <div class="login-card tfr-auth-card w-full max-w-md mx-auto lg:max-w-none lg:mx-0">

        <div class="mb-7 text-center lg:hidden">
          <a routerLink="/" class="inline-block focus:outline-none focus-visible:ring-2 focus-visible:ring-action-blue/40 rounded-md">
            <img src="assets/logo.svg" alt="TimeFlexRent" class="mx-auto h-9 w-auto" />
          </a>
        </div>

        <h2 class="tfr-auth-title text-[22px] sm:text-[24px]">
          {{ mode === 'login' ? 'Iniciar sesión' : 'Crear cuenta' }}
        </h2>
        <p class="tfr-auth-lead mb-7">
          {{ mode === 'login' ? 'Usa Google o tu email y contraseña' : 'Regístrate como propietario en TimeFlexRent' }}
        </p>

        <button
          type="button"
          (click)="loginWithGoogle()"
          [disabled]="loading || (mode === 'signup' && !acceptedLegal())"
          class="tfr-btn-google">
          <svg class="h-4 w-4 shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continuar con Google
        </button>

        <div class="flex items-center gap-3 my-6">
          <div class="tfr-auth-divider"></div>
          <span class="text-[12px] font-medium text-steel-gray">o con email</span>
          <div class="tfr-auth-divider"></div>
        </div>

        <form [formGroup]="form" (ngSubmit)="submitForm()" novalidate class="space-y-4">
          <div>
            <label class="tfr-field-label" for="email">Email</label>
            <input
              id="email"
              type="email"
              formControlName="email"
              autocomplete="email"
              placeholder="tu@email.com"
              class="tfr-input"
              [class.tfr-input--invalid]="email.invalid && email.touched" />
            @if (email.invalid && email.touched) {
              <p class="tfr-error">
                {{ email.hasError('required') ? 'El email es obligatorio.' : 'Introduce un email válido.' }}
              </p>
            }
          </div>

          <div>
            <label class="tfr-field-label" for="password">Contraseña</label>
            <input
              id="password"
              type="password"
              formControlName="password"
              [attr.autocomplete]="mode === 'login' ? 'current-password' : 'new-password'"
              placeholder="••••••••"
              class="tfr-input"
              [class.tfr-input--invalid]="password.invalid && password.touched" />
            @if (password.invalid && password.touched) {
              <p class="tfr-error">
                {{ password.hasError('required') ? 'La contraseña es obligatoria.' : 'Mínimo 6 caracteres.' }}
              </p>
            }
          </div>

          @if (errorMsg) {
            <p class="rounded-xl border border-red-200 bg-red-50 px-3 py-2.5 text-[12px] leading-snug text-red-700" role="alert">
              {{ errorMsg }}
            </p>
          }

          @if (mode === 'signup') {
            <div class="tfr-auth-legal -mb-1">
              <p class="tfr-kicker">Antes de finalizar</p>
              <ul class="mb-3 flex list-none flex-col gap-1">
                <li>
                  <a routerLink="/terminos" target="_blank" rel="noopener noreferrer" class="tfr-link-muted inline-flex items-center gap-1 text-[12px]">Términos de Servicio</a>
                </li>
                <li>
                  <a routerLink="/privacidad" target="_blank" rel="noopener noreferrer" class="tfr-link-muted inline-flex items-center gap-1 text-[12px]">Política de Privacidad</a>
                </li>
                <li>
                  <a routerLink="/terminos-propietarios" target="_blank" rel="noopener noreferrer" class="tfr-link-muted inline-flex items-center gap-1 text-[12px]">Acuerdo de Comisiones</a>
                </li>
              </ul>
              <label class="flex cursor-pointer select-none items-start gap-2">
                <input
                  type="checkbox"
                  [checked]="acceptedLegal()"
                  (change)="toggleLegal()"
                  class="mt-0.5 h-4 w-4 shrink-0 cursor-pointer accent-midnight-indigo" />
                <span class="text-[12px] leading-snug text-slate-blue">
                  He leído y acepto los documentos enlazados arriba.
                </span>
              </label>
            </div>
          }

          <button
            type="submit"
            [disabled]="loading || (mode === 'signup' && !acceptedLegal())"
            class="tfr-btn-sm w-full">
            @if (loading) {
              <svg class="h-4 w-4 shrink-0 animate-spin text-snow-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
              </svg>
            }
            {{ mode === 'login' ? 'Entrar' : 'Crear cuenta' }}
          </button>
        </form>

        <p class="mt-6 text-center text-[13px] text-slate-blue">
          {{ mode === 'login' ? '¿No tienes cuenta?' : '¿Ya tienes cuenta?' }}
          <button type="button" (click)="toggleMode()" class="tfr-link ml-1">
            {{ mode === 'login' ? 'Regístrate' : 'Inicia sesión' }}
          </button>
        </p>
      </div>
    </div>
  </div>
</div>
